
import store from "../store";
import * as types from "./constants";
import * as utils from "../utils";

export function createPoll(data) {
  const url = `/ajax/event/${window.evite_event.id}/polls/?gid=${window.guest_id}`;
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.CREATE_POLL,
      poll: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  window.dataLayer.push({'event': 'createpoll'});
}

export function cancelEditPoll(data) {
  store.dispatch({
    type: types.CANCEL_EDIT_POLL,
    poll: data
  });
  window.dataLayer.push({'event' : 'canceleditpoll'});
}

export function savePoll(data) {
  const pollId = data.id;
  const url = `/ajax/event/${window.evite_event.id}/polls/${pollId}/?gid=${window.guest_id}`;
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.SAVE_POLL,
      poll: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  window.dataLayer.push({'event': 'savepoll'});
}

export function editPoll(pollId) {
  const url = `/ajax/event/${window.evite_event.id}/polls/${pollId}?gid=${window.guest_id}`;
  window.$.get(url, (response) => {
    store.dispatch({
      type: types.EDIT_POLL,
      poll: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });

  window.dataLayer.push({'event': 'editpoll'});
}

export function deletePoll(pollId) {
  const url = `/ajax/event/${window.evite_event.id}/polls/${pollId}?gid=${window.guest_id}`;
  window.$.ajax({
      url: url,
      type: 'DELETE'
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.DELETE_POLL
  });
}

export function submitResponse(pollId, choiceId, otherOption) {
  const url = `/ajax/event/${window.evite_event.id}/polls/${pollId}/responses/?gid=${window.guest_id}`;
  const data = {
    option: choiceId,
    other_option: otherOption
  };
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.ADD_RESPONSE,
      poll: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  window.dataLayer.push({'event': 'pollvote'});
}

export function setVoted(pollId, voted, isHostVoting) {
  store.dispatch({
    type: types.SET_VOTED,
    pollId,
    voted,
    isHostVoting
  });
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/actions.es6